import React from "react";

export default function ActiveCycles() {
  return (
    <div className="w-full min-h-[30rem] flex flex-row gap-6 justify-center items-center ">
      No records found yet
    </div>
  );
}
